var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"vx-navbar-wrapper",class:_vm.classObj},[_c('vs-navbar',{staticClass:"vx-navbar navbar-custom navbar-skelton",class:_vm.textColor,attrs:{"color":_vm.navbarColorLocal}},[_c('logo',{staticClass:"fill-current text-primary cursor-pointer"}),_c('vs-spacer'),_c('profile-drop-down')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }